export default {
  data(){
    return {
      lang: {
        yearFormat: "YYYY년"
      }
    }
  },
}
